import script from "./EntranceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EntranceCard.vue?vue&type=script&setup=true&lang=js"

import "./EntranceCard.vue?vue&type=style&index=0&id=af471c28&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af471c28"]])

export default __exports__